import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=06aa4574&scoped=true"
import script from "./checkbox.ts?vue&type=script&lang=ts&external"
export * from "./checkbox.ts?vue&type=script&lang=ts&external"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=06aa4574&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa4574",
  null
  
)

export default component.exports